import React, { useState } from 'react';
import './App.scss';
import { useMount } from '@/modules/hook';

const data = [
  {
    version: '13.0.0',
    date: '（2024-08-15）',
    desc: '升级新内核，扩充直达快链',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v13_0/',
  },
  {
    version: '12.7.0',
    date: '（2024-07-08）',
    desc: '新增手机模式移动引擎功能',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v12_7/',
  },
  {
    version: '12.6.0',
    date: '（2024-06-14）',
    desc: '新增AI助手智能解读功能',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v12_6/',
  },
  {
    version: '12.5.0',
    date: '（2024-04-30）',
    desc: '新增阅读模式和小云盘功能',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v12_5/',
  },
  {
    version: '12.4.0',
    date: '（2024-03-26）',
    desc: '优化标签页和多窗口功能',
    title: '更新要点',
    content: [
      '1、网页密码保存流程优化：提示保存更及时、密码查看更便捷',
      '2、多窗口能力优化：增加当前标签选中态和退出按钮',
      '3、横竖版切换按钮位置更换',
      '4、登录后账号头像增加wx/qq标识',
      '5、标签页预览小窗出现时机优化减少延迟',
      '6、修复标签页预览小窗名称展示不全的问题',
      '7、修复更多功能点击后点击态一直不消失的问题',
      '8、修复新标签地址栏复制链接后不跳转的问题',
    ],
  },
  {
    version: '12.3.0',
    date: '（2024-02-24）',
    desc: '新增文件阵地快速管理文件',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v12_3/',
  },
  {
    version: '12.2.0',
    date: '（2024-01-04）',
    desc: '新增分屏及多窗口功能',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v3/',
  },
  {
    version: '12.1.0',
    date: '（2023-11-17）',
    desc: '新增手动自动标签分组',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide_v2/',
  },
  {
    version: '12.0.0',
    date: '（2023-08-14）',
    desc: '全新竖版工作台上线啦！',
    link: 'https://quickstart.imtt.qq.com/mobile/pc_guide/',
  },
];

function App() {
  const [navid, setNavid] = useState(0);
  useMount(() => {});

  const onload = (e: any) => {
    console.log('🚀 ~ onload ~ e:', e);
    try {
      const title = e?.target?.contentDocument?.querySelector('.footerBar .content .title');
      const more = e?.target?.contentDocument?.querySelector('#main > div.expoler > div.morebefore');

      if (more) {
        more.style = 'visibility: hidden;';
      }
      if (title && title.innerText === '往期功能介绍') {
        title.style = 'visibility: hidden;';
      }
    } catch (error) {
      console.log('🚀 ~ onload ~ error:', error);
    }
  };

  return (
    <div className="App">
      <div className="sidebar">
        <div className="title-wrapper">
          <div className="title">QQ浏览器更新日志</div>
        </div>
        <ul className="navs-ul">
          {data.map((item, index) => (
            <li
              className={`navs-li ${index === navid ? 'sel' : ''}`}
              key={index}
              onClick={() => {
                setNavid(index);
              }}
            >
              {/* {index === navid ? (
                <div className="dot-wrapper">
                  <div className="dot"></div>
                </div>
              ) : null} */}
              <div className="content">
                <div className="vd">
                  <span className="v">{item.version}</span>
                  <span className="d">{item.date}</span>
                </div>
                <div className="desc">
                  <span>{item.desc}</span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
      {data[navid].link ? (
        <div className="iframeDiv">
          <iframe id="inlineFrameExample" key={data[navid].version} src={data[navid].link} onLoad={onload}></iframe>
        </div>
      ) : null}
      {data[navid].title && data?.[navid]?.content ? (
        <div className="connteDiv">
          <div className="header">
            <div className="title">QQ浏览器 {data[navid].version} for Windows 全新发布</div>
            <div className="desc">
              <span>发布日期： {data[navid].date.replace('（', '').replace('）', '')}</span>
              <span>发布版本： QQ浏览器 {data[navid].version} for Windows</span>
            </div>
          </div>
          <div className="point">
            <div className="title">{data[navid].title}</div>
            <div className="content">
              {data[navid].content?.map((item, index) => (
                <p key={index}>{item}</p>
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default App;
